module.exports = __webpack_public_path__ + "static/media/delete.f10340a2.svg";